import React, { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Button, Box } from "@material-ui/core";
import { NextButton } from "../components/NextButton";
import { Slide } from "../components/Slide";
import { SlideIndicator } from "../components/SlideIndicator";
import { ParametersSvg } from "../components/ParametersSvg";
import { FunctionSvg } from "../components/FunctionSvg";
import { VisualiseSvg } from "../components/VisualiseSvg";
import { withRouter, RouteComponentProps } from "../utils/useRouter";
import colors from "../constants/colors";
import { store } from "../store";

const slides = [
  {
    text: "You input design request parameters - HornWizard will give you a calculated response that will allow you to test the viability of your design.",
    image: <ParametersSvg />,
  },
  {
    text: "Our rapid design algorithm crunches the numbers but HornWizard cannot give you a completely optimised horn or one that might be ready to manufacture.",
    image: <FunctionSvg />,
  },
  {
    text: "Visualise the results – Remember though that a fully optimised design takes one of our skilled horn designers a considerable amount of time, expertise and judgement, balancing trade-offs for the specific application in a way that an automatic algorithm can’t do.",
    image: <VisualiseSvg />,
  },
];

interface IGuideProps extends RouteComponentProps {}

const Guide: FC<IGuideProps> = observer(({ history }) => {
  const { resetState } = store;
  const [slideIndex, setSlideIndex] = useState(0);
  const classes = styles();

  useEffect(() => {
    resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const incrementSlide = () => {
    if (slideIndex === 2) history.push("/parameters");
    if (slideIndex + 1 < slides.length) setSlideIndex(slideIndex + 1);
  };

  const selectSlide = (index: number) => {
    setSlideIndex(index);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.box}>
        <Button
          className={classes.skip}
          onClick={() => history.push("/parameters")}
        >
          Skip
        </Button>
        <Slide text={slides[slideIndex].text} svg={slides[slideIndex].image} />
        <SlideIndicator selectSlide={selectSlide} slideIndex={slideIndex} />
        <Box className={classes.next}>
          <NextButton onClick={incrementSlide} />
        </Box>
      </Box>
    </Box>
  );
});

const styles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
  },
  box: {
    display: "flex",
    flex: 1,
    padding: "50px 20px 100px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    maxWidth: 600,
  },
  next: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  skip: {
    color: colors.primary,
    position: "absolute",
    top: 10,
    right: 10,
  },
}));

export default withRouter(Guide);
